module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Nevada Reapportionment and Redistricting 2021","short_name":"Redistricting 2021","start_url":"/","background_color":"#113884","theme_color":"#d7deda","display":"browser","include_favicon":false,"icon":"src/images/lcb-logo-sm.png","cache_busting_mode":"query","legacy":true,"theme_color_in_head":true,"cacheDigest":"870550e403730ddb9b8c57e4a448fab4"},
    },{
      plugin: require('../node_modules/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"lcb-research","path":"/nopreview","previews":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
